import * as React from 'react';

// Closed paint primitive for loading placeholders. Caller wraps with a
// sized container (`<div className="tw-h-4 tw-w-full">`); Skeleton
// fills it with an animated pulse in the chosen tone.
//
// Two tones cover the contrast spectrum of the design system:
//   - `subtle` (`bg-muted`): for skeletons over white surfaces
//     (Surface neutral, default page background).
//   - `strong` (`bg-border`): for skeletons over already-muted
//     surfaces (Table even rows, muted Surfaces, tinted parents).
// `border` is reused as the strong tone because it is the only
// canonical token between `muted` (96% lightness) and
// `muted-foreground` (47%) without brand or status meaning.
//
// Sizing is the wrapper's job — Skeleton fills the container with
// `tw-h-full tw-w-full`. Shape is baked as a binary axis: `circle`
// false (default) paints a soft-rounded bar (`tw-rounded-md`), `true`
// paints a circular blob (`tw-rounded-full`) for avatar-style
// placeholders. Refuses className/style.

const TONE_CLASSNAME = {
    subtle: 'tw-bg-muted',
    strong: 'tw-bg-border'
};

const Skeleton = ({ circle = false, className: _className, style: _style, tone = 'subtle' }) => {
    const shapeClassName = circle ? 'tw-rounded-full' : 'tw-rounded-md';

    return (
        <div className={`tw-h-full tw-w-full tw-animate-pulse ${shapeClassName} ${TONE_CLASSNAME[tone]}`} />
    );
};

export { Skeleton };
